function fallbackCopyTextToClipboard(text) {
  const textArea = document.createElement('textarea')
  textArea.value = text

  textArea.style.position = 'fixed'
  textArea.style.top = '0'
  textArea.style.left = '0'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  let error = null
  try {
    if (!document.execCommand('copy')) error = 'copy error'
  } catch (err) {
    error = err
  }

  document.body.removeChild(textArea)
  return error ? Promise.reject(error) : Promise.resolve()
}

// webpack:BrowserOnly
export default function copyTextToClipboard(text) {
  return !navigator.clipboard ? fallbackCopyTextToClipboard(text) : navigator.clipboard.writeText(text)
}
